import { notificationToast, toast } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AppContext from 'src/AppContext';
import { getErrorMsgForToast, getErrorMsgFromLicenseSystemSubscription } from 'src/components/toastErrorHandler';
import { useAddNewLicenseSystemToOrg } from 'src/graphql/useAddNewLicenseSystemToOrg';
import { getCreateNewLicenseSystemEvent } from 'src/tracking';
import { LicenseSystemSubscriptionViewModel } from 'src/viewModels/LicenseSystem';
import { AddNewLicenseSystemNotificationToast, addNewLicenseSystemNotificationToastId } from './AddNewLicenseSystemNotificationToast';
import AddNewLicenseSystemToOrgModal from './AddNewLicenseSystemToOrgModal';
import { createOrReactivateLicenseSystemSubscriptionResponseHandler } from './createOrReactivateLicenseSystemSubscriptionResponseHandler';
import { decodeBase64 } from 'src/shared/base64Utils';

export interface AddNewLicenseSystemToOrgModalContainerProps {
    onClose?: () => void;
};

const AddNewLicenseSystemToOrgModalContainer: FunctionComponent<AddNewLicenseSystemToOrgModalContainerProps> = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const { trackEvent } = useContext(AppContext);
    const onSubscriptionResponse = (args: LicenseSystemSubscriptionViewModel) => {
        createOrReactivateLicenseSystemSubscriptionResponseHandler({
            ...args,
            error: args.error
                ? getErrorMsgFromLicenseSystemSubscription(args.error.errorType, args.licenseSystemId, t)
                : undefined,
            toBeClosedToastIds: [addNewLicenseSystemNotificationToastId],
            notificationTitle: t('SuccessNotificationWithDownloadLink.activation_notification_title', 'Activation file ready for download'),
            decoderFn: decodeBase64,
        });
    };
    const showAddNewLicenseSystemNotificationToast = () => {
        notificationToast({
            content: <AddNewLicenseSystemNotificationToast />,
            id: addNewLicenseSystemNotificationToastId,
        });
    };
    const addNewLicenseSystemToOrg = useAddNewLicenseSystemToOrg(params.orgId!, showAddNewLicenseSystemNotificationToast, onSubscriptionResponse);

    const handleSubmit = async (fileContent: string) => {
        try {
            trackEvent(getCreateNewLicenseSystemEvent());
            await addNewLicenseSystemToOrg.mutateAsync(fileContent);

        } catch (error) {
            toast.error(getErrorMsgForToast(error, t));
        }
    };

    return (
        <AddNewLicenseSystemToOrgModal
            onClose={props.onClose}
            onSubmit={(file: string) => handleSubmit(file)}
        />
    );
};

export default AddNewLicenseSystemToOrgModalContainer;